import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSubscription } from '../../contexts/SubscriptionContext';

const SubscriptionExpiredPage = () => {
  const { logout } = useAuth();
  const { status, refresh, loading } = useSubscription();
  const navigate = useNavigate();

  const endDate = status?.endDate ? new Date(status.endDate).toLocaleDateString() : '—';
  const graceEnd = status?.graceEndDate ? new Date(status.graceEndDate).toLocaleDateString() : null;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fef2f2 0%, #fff7ed 100%)',
      padding: '20px',
    }}>
      <Container style={{ maxWidth: 560 }}>
        <Card className="border-0 shadow-lg" style={{ borderRadius: 24, overflow: 'hidden' }}>
          <div style={{
            background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
            padding: '40px 32px 32px',
            textAlign: 'center',
            color: '#fff',
          }}>
            <div style={{
              width: 72,
              height: 72,
              margin: '0 auto 16px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 36,
            }}>
              <i className="bi bi-exclamation-triangle-fill" />
            </div>
            <h2 style={{ fontWeight: 800, margin: 0 }}>Subscription Expired</h2>
            <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: 14 }}>
              Your restaurant's subscription has ended. The admin dashboard is locked until it's renewed.
            </p>
          </div>

          <Card.Body style={{ padding: '28px 32px' }}>
            <div style={{ display: 'grid', gap: 12, marginBottom: 24 }}>
              <Row label="Plan" value={status?.planName || '—'} />
              <Row label="Expired on" value={endDate} />
              {graceEnd && <Row label="Grace ended" value={graceEnd} />}
              <Row label="Status" value={(status?.status || 'expired').toUpperCase()} />
            </div>

            <div style={{
              background: '#fff7ed',
              border: '1px solid #fed7aa',
              borderRadius: 12,
              padding: '14px 16px',
              fontSize: 13,
              color: '#9a3412',
              marginBottom: 20,
            }}>
              <strong>Consumer app stays live.</strong> Customers can still browse and order on the menu page — only the admin / branch / kitchen / cashier apps are locked.
            </div>

            <Button
              variant="primary"
              onClick={() => navigate('/renew-subscription')}
              style={{ width: '100%', borderRadius: 12, fontWeight: 700, marginBottom: 10 }}
            >
              <i className="bi bi-credit-card-fill" style={{ marginRight: 8 }} />
              Renew now
            </Button>

            <div style={{ display: 'flex', gap: 10 }}>
              <Button
                variant="outline-secondary"
                onClick={refresh}
                disabled={loading}
                style={{ flex: 1, borderRadius: 12, fontWeight: 600 }}
              >
                {loading ? 'Checking…' : 'I just renewed — refresh'}
              </Button>
              <Button
                variant="outline-danger"
                onClick={logout}
                style={{ flex: 1, borderRadius: 12, fontWeight: 600 }}
              >
                Sign out
              </Button>
            </div>

            <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#64748b' }}>
              Secure payment via our platform gateway. Webdekho support: contact your account manager.
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 14px', background: '#f8fafc', borderRadius: 10 }}>
    <span style={{ color: '#64748b', fontSize: 13, fontWeight: 600 }}>{label}</span>
    <span style={{ color: '#0f172a', fontSize: 13, fontWeight: 700 }}>{value}</span>
  </div>
);

export default SubscriptionExpiredPage;
